
export { localStorageUtils } from "/codebuild/output/src1051443037/src/packages/utils/src/storage/index.ts"